import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SalarySlip } from 'src/app/shared/models/domain';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-salary-slip',
  templateUrl: './salary-slip.component.html',
  styleUrls: ['./salary-slip.component.scss']
})
export class SalarySlipComponent implements OnInit {
  @Input() salarySlip: SalarySlip;
  @Input() isSalarySlipVisible: boolean = false;
  @Input() paymentId: number;
  @Input() salaryDate: string;
  public netInWords: string;
  constructor(
    public activeModal: NgbActiveModal,
    private employeeService: EmployeeService,
  ) { }

  ngOnInit(): void {
    if (this.paymentId) {
      this.getSalarySlip(this.paymentId);
    }
    console.log(this.salaryDate,"arun")
  }

  private getSalarySlip(pid: number) {
    this.employeeService.getSalarySlip(pid).subscribe({
      next: (salarySlip: SalarySlip) => {
        this.salarySlip = salarySlip;
      },
    });
  }

  getTotalEarnings(): number {
    return Object.values(this.salarySlip.earnings).reduce((acc, val) => acc + val, 0);
  }

  getTotalDeductions(): number {
    return Object.values(this.salarySlip.deductions).reduce((acc, val) => acc + val, 0);
  }

  public downloadImage() {
    const element = document.getElementById('payslip-content');
    if (element) {
      html2canvas(element).then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'salary-slip.png';
        link.click();
      });
    }
  }
}
